import { Component, ViewChild, OnInit, OnDestroy, Input } from '@angular/core';
import { PrintComponent } from '../../../blocks/print-component/print-component';
import { TranslateService } from '@ngx-translate/core';
import { UserSessionService, StockParms } from '../../../shared';
import { StepperComponent } from '../../../blocks';
import { takeUntil } from 'rxjs/operators'; import { Observable, Subject } from 'rxjs';
import { poOrderSupplyDetailService } from '../../po-order-supply/po-order-supply.service';
@Component({
  selector: 'offers-needed-print',
  templateUrl: './offers-needed-print.component.html', providers: [poOrderSupplyDetailService]
})

export class OffersNeedPrintComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  items = [];
  row: any = <any>{};
  requestNeedSerial: any = <any>{};
  allowReset: number;
  @ViewChild('printComponent') printComponent: PrintComponent;
  @Input() myStepNumber: number;
  @Input() PoOrderFlageForPrint: any;

  patientFlag: any;
  @Input() stepperComponent: StepperComponent;
  constructor(
    private _poOrderSupplyDetailService: poOrderSupplyDetailService,
    public translate: TranslateService,
    private _userSessionService: UserSessionService
  ) { }

  ngOnInit() {
    if (this._userSessionService.getSessionKey('OfferPrice')) {
      this.requestNeedSerial = this._userSessionService.getSessionKey('OfferPrice');
    }
    
    this._userSessionService.subscribeToKey$('OfferPrice')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.requestNeedSerial = keys.value;
          this.getGetRequestNeedResetInfo();
        }
      });

  }

  getGetRequestNeedResetInfo() {
    if (this.requestNeedSerial.masterSerial != undefined || this.requestNeedSerial.masterSerial != null) {
      var prem: StockParms = {
        serial: this.requestNeedSerial.masterSerial
      }
      this.row = <any>{};
      this.items = [];
      this._poOrderSupplyDetailService.getAllOfferPrice(prem)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          r => {
            if (r) {
              if (r.data && r.data.length > 0) {
                this.row = r.data[0];
              }
              if (r.data1 && r.data1.length > 0) {
                this.items = r.data1;
              }

              setTimeout(() => { if (this.printComponent) { this.printComponent.PrintView() } }, 200);
            }
          }
          , error => console.log(error),
          () => null
        );
    }
  }
  htmlcontent 
  getPrintHtml(){
    const HtmlPrint = document.getElementById('datasection');
    this.htmlcontent=HtmlPrint.innerHTML ; 
    console.log(HtmlPrint);
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



